<template>
  <div>
    <loader v-if="!pageLoaded"></loader>

    <div v-else class="px-4 mt-n2">
      <v-container class="mb-4">
        <v-tabs-items v-model="usersTab">
          <v-tab-item value="tab-active" class="grey lighten-5">
            <active-users
              :users="activeUsers"
              @deleteInviteFromList="deleteInviteFromList"
            ></active-users>
          </v-tab-item>

          <v-tab-item value="tab-pending" class="grey lighten-5">
            <pending-users
              :users="pendingUsers"
              @deleteInviteFromList="deleteInviteFromList"
            ></pending-users>
          </v-tab-item>
        </v-tabs-items>
      </v-container>

      <v-btn
        link
        :to="{ name: 'users.create' }"
        dark
        fab
        bottom
        right
        fixed
        color="primary"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

    </div>
  </div>
</template>

<script>
import ActiveUsers from '@/components/users/ActiveUsers'
import Loader from '@/components/Loader'
import PendingUsers from '@/components/users/PendingUsers'
import { mapGetters } from 'vuex'

export default {
  name: 'Users',

  components: {
    ActiveUsers,
    Loader,
    PendingUsers
  },

  data () {
    return {
      invites: [],
      pageLoaded: false
    }
  },

  mounted () {
    Promise.all([
      this.getInvites()
    ])
      .then(() => {
        this.pageLoaded = true

        this.$store.commit('SET_USERS_TAB', 'tab-active')
      })
  },

  computed: {
    ...mapGetters([
      'usersTab'
    ]),

    activeUsers () {
      return this.invites.filter(item => item.user)
    },

    pendingUsers () {
      return this.invites.filter(item => !item.user)
    }
  },

  methods: {
    deleteInviteFromList (id) {
      this.invites = this.invites.filter(item => item.id !== id)
    },

    getInvites () {
      return this.$http.get('/invites')
        .then(({ data }) => {
          this.invites = data.invites
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
